import React, { useEffect, useState } from 'react';
import Page from "../../../components/Page";
import EventDetailsSection from "../../../components/NewDesign/Event/EventDetailsSection"

function EventDetailPage() {
  return (
    <>
        <Page>
            <EventDetailsSection />
        </Page>
    </>
  )
}

export default EventDetailPage